var ScappFunctions = {
    CustomerBaseApi : class {
        constructor(secretToken, secretValue, secretTime) {
            if (!secretToken?.trim() || !secretValue?.trim() || !secretTime?.trim()) {
                return;
            }
            this.secretToken = secretToken;
            this.secretValue = secretValue;
            this.secretTime = secretTime;
        }
        #createEndpoint(type) {
            if (!type?.trim()) {
                console.error("type is required");
                throw new Error("type is required");
            }
            const baseurl = '/apps/scapp/';
            if (type === 'login') {
                return `${baseurl}login`;
            } else if (type === 'signup') {
                return `${baseurl}customers/regist`;
            } else if (type === 'agree_rule') {
                return `${baseurl}rule/update`;
            } else if (type === 'sso_customer_base') {
                return `${baseurl}customers/update`;
            } else if (type === 'notify_change') {
                return `${baseurl}customers/send`;
            } else if (type === 'get_customer') {
                return `${baseurl}customers/get`;
            } else if (type === 'change_customer') {
                return `${baseurl}customers/change`;
            } else if (type === 'publish_coupon') {
                return `${baseurl}coupon/create`;
            } else if (type === 'get_scheduled_point') {
                return `${baseurl}point/scheduled`;
            }
            console.error("Unsupported type:", type);
            throw new Error("Unsupported type:", type);
        }
        async post(type, postData) {

            const url = this.#createEndpoint(type);

            const headers = {
                'Content-Type': 'application/json',
            }
            if(this.secretToken && this.secretTime && this.secretValue){
                headers['Secret-Token'] = this.secretToken;
                headers['Secret-Time'] = this.secretTime;
                headers['Secret-Value'] = this.secretValue;
            }
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers,
                    body: JSON.stringify(postData),
                });
                if (!response.ok) {
                    console.error(`HTTP error! status: ${response.status}`);
                    return false;
                }
                const data = await response.json();
                return data;
            } catch (err) {
                console.error(err);
                return false;
            }
        }
    },
    sortCoupons:(coupons) => {
        return coupons.sort((a, b) => {
            if (a.discountClass !== b.discountClass) {
            return a.discountClass.localeCompare(b.discountClass);
            }
            if (a.discountType !== b.discountType) {
            return a.discountType.localeCompare(b.discountType);
            }
            if (a.discountAmount !== b.discountAmount) {
            return a.discountAmount - b.discountAmount;
            }
            if (a.discountPercentage !== b.discountPercentage) {
            return a.discountPercentage - b.discountPercentage;
            }
            if (a.discountOnQuantity !== b.discountOnQuantity) {
            return a.discountOnQuantity - b.discountOnQuantity;
            }
            if (a.endsAt && b.endsAt) {
                return a.endsAt.localeCompare(b.endsAt);
            }
            if (a.endsAt) {
                return -1; // aにendsAtがあり、bにない場合、aを前に
            }
            if (b.endsAt) {
                return 1; // bにendsAtがあり、aにない場合、bを前に
            }
            return 0; // 両方ともendsAtがない場合は同じとみなす
        });
    },
    formatCoupons:(coupons) => {
        if (!coupons.length) {
            return [];
        }
        const sortedCoupons = ScappFunctions.sortCoupons(coupons);
        console.log(sortedCoupons);
        const formattedCoupons = [];
        let currentGroupingTitle = '';
        let currentCoupons = [];
        sortedCoupons.forEach((coupon, index) => {
            const groupingTitle = ScappFunctions.getCouponTitle(coupon);
            if (currentGroupingTitle !== groupingTitle) {
            if (currentGroupingTitle) {
                formattedCoupons.push({
                title: currentGroupingTitle,
                coupons: currentCoupons,
                });
            }
            currentGroupingTitle = groupingTitle;
            currentCoupons = [];
            }
            currentCoupons.push({
            isUsed: false,
            ...coupon,
            });
            // 最後のクーポンを処理するためのチェック
            if (index === sortedCoupons.length - 1) {
            //   console.log('grouping last', ScappFunctions.getCouponTitle(currentCoupon));
            formattedCoupons.push({
                title: groupingTitle,
                coupons: currentCoupons,
            });
            }
        });

        return formattedCoupons;
    },
    getCouponTitle:(coupon) => {
        if (coupon.discountClass == 'SHIPPING') {
            return 'サンリオベビー公式オンラインショップ 送料無料クーポン';
        }
        if (coupon.discountType == 'percentage') {
            return `サンリオベビー公式オンラインショップ お買い物クーポン${coupon.discountPercentage}%割引`;
        }
        if (coupon.discountType == 'fixed_amount') {
            return `サンリオベビー公式オンラインショップ お買い物クーポン${coupon.discountAmount}円（併用可）`;
        }
        return `サンリオベビー公式オンラインショップ その他クーポン`;
    },
    validateEmail:(email) => {
        const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailPattern.test(email)) {
            return false;
        }
        return true;
    },
    validatePassword:(password) => {
        if (password.length < 1) {
            return false;
        }
        return true;
    }

}
